import React from "react";
import AnimatedHeading from "../AnimatedHeading";
import { IMG } from "../../assetsBase";

const highlights = [
  {
    icon: "icon5.png",
    title: "Multidisciplinary Expertise",
    description:
      "Technology, business, and international supply capabilities brought together under one brand.",
  },
  {
    icon: "icon6.png",
    title: "Long-Term Partnerships",
    description:
      "Committed to quality, collaboration, and building lasting relationships with every client.",
  },
];

function About() {
  return (
    <section className="orbia-about_one pt-90 pb-120" id="about">
      <div className="shape">
        <img src={`${IMG}/about/testimonial-shape.png`} alt="shape" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-10">
            <div className="orbia-image-box mb-5 mb-xl-0">
              <div
                className="orbia-image image_one"
                data-aos="fade-down"
                data-aos-duration="800"
              >
                <img src={`${IMG}/about/about-img1.jpg`} alt="Lozrian" />
              </div>
              <div
                className="orbia-image image_two"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <img
                  src={`${IMG}/about/about-img2.png`}
                  alt="Lozrian"
                  width={257}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-lg-10">
            <div className="orbia-content-box">
              <div className="section-title">
                <span
                  className="sub-title"
                  data-aos="fade-down"
                  data-aos-duration="1000"
                >
                  About Us
                </span>
                <AnimatedHeading>
                  A Multidisciplinary Solutions Company
                </AnimatedHeading>
              </div>
              <p className="mb-30" data-aos="fade-up" data-aos-duration="1200">
                Lozrian is a multidisciplinary solutions company that brings
                together technology, business expertise, and international
                supply capabilities under one brand. We partner with businesses
                to develop innovative digital products, support strategic
                growth, and provide reliable sourcing and trading solutions.
              </p>
              <div className="iconic-box-list mb-30">
                {highlights.map((item, index) => (
                  <div
                    className="orbia-iconic-left-box style-one mb-30"
                    data-aos="fade-up"
                    data-aos-duration={1400 + index * 200}
                    key={item.title}
                  >
                    <div className="icon">
                      <img src={`${IMG}/icon/${item.icon}`} alt="icon" />
                    </div>
                    <div className="content">
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                className="orbia-button"
                data-aos="fade-up"
                data-aos-duration="1800"
              >
                <a href="#services" className="theme-btn gradient-btn">
                  Explore Our Services<i className="far fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
